import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { LockKeyhole, Mail } from "lucide-react";
import AuthModal from "@/components/AuthModal";

export default function ComingSoonPage() {
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background flex flex-col relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-noise opacity-[0.03] pointer-events-none mix-blend-overlay z-10" />
      <div className="absolute top-0 right-0 -translate-y-1/4 translate-x-1/4 w-[800px] h-[800px] bg-primary/10 rounded-full blur-[120px] pointer-events-none" />
      <div className="absolute bottom-0 left-0 translate-y-1/4 -translate-x-1/4 w-[600px] h-[600px] bg-secondary/10 rounded-full blur-[100px] pointer-events-none" />

      {/* Header */}
      <header className="absolute top-0 w-full p-6 flex justify-between items-center z-20">
        <div className="flex items-center gap-2">
          <div className="w-10 h-10 bg-primary rounded-xl flex items-center justify-center shadow-lg">
            <span className="text-white font-display font-bold text-xl">K</span>
          </div>
          <span className="font-display font-bold text-xl tracking-tight text-foreground hidden sm:block">
            Kayn<span className="text-primary">'in</span>
          </span>
        </div>
        <Button variant="outline" className="font-body font-semibold border-primary/20 hover:bg-primary/5 gap-2" onClick={() => setIsAuthModalOpen(true)}>
          <LockKeyhole className="w-4 h-4" /> Espace Partenaires
        </Button>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex flex-col items-center justify-center p-6 text-center z-20 max-w-4xl mx-auto w-full relative">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/10 border border-primary/20 text-primary text-sm font-semibold mb-8 animate-in fade-in slide-in-from-bottom-4">
          <span className="w-2 h-2 rounded-full bg-primary animate-pulse" />
          Ouverture Bientôt
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-display font-bold text-foreground leading-tight tracking-tight mb-6 animate-in fade-in slide-in-from-bottom-6 delay-100">
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-primary/70">Plateforme en construction</span>
        </h1>

        <div className="text-lg md:text-xl text-muted-foreground font-body max-w-2xl mx-auto mb-12 animate-in fade-in slide-in-from-bottom-8 delay-200 space-y-4">
          <p>
            Nous préparons une expérience politique inédite pour le Maroc. L'accès grand public sera bientôt disponible.
          </p>
          <p className="text-base">
            Pour toute demande de partenariat ou information, contactez-nous :{" "}
            <a href="mailto:contact@kaynin.ma" className="text-primary hover:underline font-semibold transition-colors">
              contact@kaynin.ma
            </a>
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-in fade-in slide-in-from-bottom-10 delay-300 w-full max-w-md mx-auto">
          <Button size="lg" className="w-full sm:w-auto font-body font-bold text-base h-14 px-8 shadow-xl shadow-primary/20 gap-2" onClick={() => setIsAuthModalOpen(true)}>
            Se connecter
          </Button>
          <Button size="lg" variant="outline" className="w-full sm:w-auto font-body font-bold text-base h-14 px-8 border-border bg-background/50 backdrop-blur-sm gap-2" onClick={() => setIsAuthModalOpen(true)}>
            <Mail className="w-4 h-4" /> Devenir Partenaire
          </Button>
        </div>

        <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 animate-in fade-in opacity-50 delay-500">
          {['Partis Politiques', 'Institutions', 'ONG', 'Médias'].map((label, i) => (
            <div key={label} className="text-center space-y-2">
              <div className="w-12 h-12 mx-auto rounded-full bg-muted/50 border border-border flex items-center justify-center">
                <LockKeyhole className="w-5 h-5 text-muted-foreground opacity-50" />
              </div>
              <p className="text-sm font-semibold font-body text-muted-foreground">{label}</p>
            </div>
          ))}
        </div>
      </main>

      {/* Footer */}
      <footer className="w-full p-6 text-center z-20">
        <p className="text-sm text-muted-foreground font-body">
          © {new Date().getFullYear()} Kayn'in. Tous droits réservés.
        </p>
      </footer>

      <AuthModal isOpen={isAuthModalOpen} onClose={() => setIsAuthModalOpen(false)} />
    </div>
  );
}
